export const AdminLogHistoryFilterActionTypes = [
  {name: "ایجاد (create)", value: "CREATE"},
  {name: "ویرایش (edit)", value: "EDIT"},
  {name: "حذف (delete)", value: "DELETE"},
];

export const AdminLogHistoryFilterLogTypes = [
  {name: "USER", value: "USER"},
  {name: "ADMIN", value: "ADMIN"},
  {name: "SPECIALIST_COMMENT", value: "SPECIALIST_COMMENT"},
  {name: "SPECIALIST_CARD", value: "SPECIALIST_CARD"},
  {name: "INVOICE", value: "INVOICE"},
  {name: "FORUM_CATEGORY", value: "FORUM_CATEGORY"},
  {name: "FORUM", value: "FORUM"},
  {name: "MESSAGE", value: "MESSAGE"},
  {name: "USER_CONVERSATION", value: "USER_CONVERSATION"},
  {name: "CONVERSATION", value: "CONVERSATION"},
  {name: "CONVERSATION_AD", value: "CONVERSATION_AD"},
  {name: "CONFIG", value: "CONFIG"},
  {name: "CODE", value: "CODE"},
  {name: "BLOG_CATEGORY", value: "BLOG_CATEGORY"},
  {name: "BLOG", value: "BLOG"},
  {name: "ADVICE", value: "ADVICE"},
  {name: "GOAL", value: "GOAL"},
  {name: "AVATAR", value: "AVATAR"},
  {name: "VARIANT", value: "VARIANT"},
  {name: "USER_VARIANT", value: "USER_VARIANT"},
  {name: "EXPERIMENT", value: "EXPERIMENT"},
  {name: "CHILD_WEEK", value: "CHILD_WEEK"},
];